<template>
  <div class="signature">
    <router-link to="/legal">
      Rechtliches & Impressum
    </router-link>
    <div class="h-divider" />
    <a id="signatureCodeIcon">
      <font-awesome-icon :icon="['fal', 'code']" />
    </a>
    by
    <a :href="homepage">{{ developer }}</a>
  </div>
</template>

<script>
export default {
  name: 'signature',
  data: function () {
    return {
      developer: 'Felix Hofmann',
      homepage: 'https://felix.hofmann.rocks',
      elements: [
        {
          icon: ['fab', 'linux'],
          size: '2x',
          link: 'https://www.archlinux.org/',
        },
        {
          icon: ['fab', 'vuejs'],
          size: '2x',
          link: 'https://vuejs.org/',
        },
        {
          icon: ['fab', 'font-awesome-flag'],
          size: '2x',
          link: 'https://fontawesome.com/',
        },
        'break',
        {
          icon: ['far', 'coffee'],
          size: '3x',
          link: 'https://de.wikipedia.org/wiki/Kaffee',
        },
        {
          icon: ['fas', 'heart'],
          size: '3x',
          link: 'https://de.wikipedia.org/wiki/Liebe',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
  .signature {
    display: inline-block;
  }
  .h-divider {
    display: inline-block;
    &:after {
      margin: 0 .7em;
      font-size: 1.3em;
      content: "|";
    }
  }
</style>
